import React from 'react'

export default function Footer({ bgColour, titleColour}) {
  const currentYear = new Date().getFullYear()
  
  return ( 
    <footer id='footer_container' style={{background: bgColour}}>
        <p id='footer_copyright' style={{ color: titleColour}}><span>©</span>What's in your fridge?<span> - {currentYear}</span></p>
    </footer>
  )
}
